var map = {
	"./gifs/adoptedcourse.gif": 4400,
	"./gifs/manageusers.gif": 7499,
	"./gifs/orphaned.gif": 1635,
	"./gifs/settings.gif": 6809,
	"./gifs/substituteteacher.gif": 2095,
	"./gifs/supporteducator.gif": 7185,
	"./gifs/teacher.gif": 6074
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8089;